import React from 'react';
import { Pagination, PaginationItem } from '@material-ui/lab';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { buildThemeHref, readDiscoveryTheme } from '../../lib/discoveryThemes';
import useStyles from '../styles';

const MultiSpeciesPagination = ({ page }) => {
    const { numberOfPages } = useSelector((state) => state.species);
    const classes = useStyles();
    const location = useLocation();
    const activeTheme = readDiscoveryTheme(location.search);

    return (
        <Pagination 
            classes={{ ul: classes.ul }}
            count={numberOfPages}
            page={Number(page) || 1}
            variant="outlined"
            color="primary"
            renderItem={(item) => (
                <PaginationItem
                    { ...item }
                    component={Link}
                    to={buildThemeHref('/species', location.search, activeTheme, { page: item.page })}
                />
            )}
        />
    );
};

export default MultiSpeciesPagination;
